export default "c1a54e99db77defb.svg"